Liferay.on(
    'allPortletsReady',

    /*
    This function gets loaded when everything, including the portlets, is on
    the page.
    */

    () => {

        const axObserver = new MutationObserver((mutations) => {
            const dateSentinals = document.querySelectorAll('[data-focus-scope-start], [data-focus-scope-end]');
            const datePickerPresentInDOM = document.querySelector('.date-picker');
            if(document.querySelectorAll(datePickerPresentInDOM && dateSentinals.length > 0)) {

                dateSentinals.forEach(ele => {
                    if (
                        ele.hasAttribute("data-focus-scope-start") ||
                        ele.hasAttribute("data-focus-scope-end")
                    ) {
                        if (ele.getAttribute("aria-hidden") === "true") {
                            ele.removeAttribute("aria-hidden");
                        }
                    }
                })
            }
        });

        axObserver.observe(document.body, {
            childList: true,
            subtree: true
        });
    });